<template>
  <Section :content="trinappSuite" />
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import Section from '@/components/section.vue';
export default {
  name: 'SectionTrinappSuite',
  components: {
    Section,
  },
  data() {
    return {
      trinappSuite: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'TrinApp\u2122 Suite',
        headlineIcon: 'launchpad.png',
        paragraphs: [
          'Convert documents and files into linked intelligentPDF\u2122, visualize and navigate systems, and fine-tune collaboration with granular access controls.',
          'Whether at the office or on site, the TrinApp\u2122 suite of apps can be used on any internet connected device.'
        ],
        id: 'trinapp-suite',
        image: 'trinapp-suite-globe.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
        learnMoreLink: '/trinapp'
      },
    }
  }
};
</script>
